module.exports = __webpack_public_path__ + "static/media/_DSC6131.20acba39.jpg";